import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import { APP_NAV, APPBAR_NAV } from "routes/APP_ROUTES";
import { MdClose } from "react-icons/md";
import { isImageUrl } from "helper/Functions";

const Appbar = ({ onLinkClick }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavigation = (path) => {
    setIsMenuOpen(false); // Close menu when navigating
    navigate(path);
  };

  const appNavItems = APP_NAV();
  const appNavBarItems = APPBAR_NAV();
  return (
    <>
      <style jsx="true">
        {`
          .appbar-menu li i {
            width: 30px;
            height: 30px;
            color: #fff;
            border-radius: 4px;
            font-size: 18px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          }
          .appbar-menu li i:before {
            position: relative;
            z-index: 1;
          }
          .appbar-menu li i:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 4px;
            background-image: radial-gradient(circle at -14% 113%, #000000a6, #0000 120%);
          }
        `}
      </style>
      <div
        className={`fixed z-50 bottom-0 h-[calc(100%-50px)] overflow-x-auto w-full bg-body text-white transform ${
          isMenuOpen ? "translate-y-0" : "translate-y-full"
        } transition-transform duration-300 ease-in-out z-50`}
      >
        {/* Header Section */}
        <div className="flex justify-between items-center px-2 py-3 border-b border-white/5">
          <div className="w-36 fix">MENU</div>
          <button className="text-white text-2xl pr-2" onClick={() => setIsMenuOpen(false)}>
            <MdClose />
          </button>
        </div>

        <hr className="border-[#263044]" />
        <ul className="px-2 appbar-menu mb-[4.5rem]">
          {appNavItems.map((item, index) => (
            <li key={index}>
              <NavLink
                onClick={() => {
                  onLinkClick(item.child || null);
                  handleNavigation(item.path);
                }}
                to={item.path}
                className="flex items-center gap-3 p-[10px] rounded mt-2 bg-white bg-opacity-10"
              >
                {isImageUrl(item.iconAppbarMenu) ? <img src={item.iconAppbarMenu} alt={item.label} /> : item.iconAppbarMenu}
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      {/* Bottom Navigation Bar */}
      <nav className="fixed z-50 bottom-0 w-full border-t border-gray-600">
        <div className="bg-body bg-opacity-90 text-gray-500 flex justify-around items-center">
          {appNavBarItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              onClick={() => {
                onLinkClick(item.child || null);
                handleNavigation(item.path);
              }}
              className={({ isActive }) =>
                `flex flex-col flex-1 items-center font-light py-1 ${isActive ? " text-white " : "text-gray hover:text-white hover:bg-[#1c1c1c]"}`
              }
            >
              <span className="">
                {isImageUrl(item.icon) ? (
                  <img className="h-5" src={item.icon} alt={item.icon} />
                ) : (
                  <span className="text-[24px] leading-none">{item.icon}</span>
                )}
              </span>
              <span className="text-xs">{item.label}</span>
            </NavLink>
          ))}
          <button
            className="flex flex-col flex-1 py-1 items-center gap-1 font-light text-gray hover:bg-[#263044] hover:text-white"
            onClick={() => setIsMenuOpen(true)}
          >
            <FaBars size={24} />
            <span className="text-xs">Menu</span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default Appbar;
